// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__34QNL","footer":"ModalError_footer__4r0vI"};